/* ═══════════════════════════════════════
   AURUM Finance — Gold Price Chart
   Canvas2D historical gold price (XAUEUR)
   ═══════════════════════════════════════ */

(function() {
  // Approximate annual average XAUEUR prices 2000-2024
  var data = [
    {y:2000,v:315},{y:2001,v:310},{y:2002,v:330},{y:2003,v:330},{y:2004,v:330},
    {y:2005,v:350},{y:2006,v:480},{y:2007,v:500},{y:2008,v:620},{y:2009,v:680},
    {y:2010,v:950},{y:2011,v:1200},{y:2012,v:1290},{y:2013,v:1000},{y:2014,v:940},
    {y:2015,v:1050},{y:2016,v:1170},{y:2017,v:1100},{y:2018,v:1070},{y:2019,v:1360},
    {y:2020,v:1550},{y:2021,v:1530},{y:2022,v:1720},{y:2023,v:1850},{y:2024,v:2200}
  ];

  function drawGoldChart() {
    var canvas = document.getElementById('aurumGoldChart');
    if (!canvas) return;
    var wrap = canvas.parentElement;
    var dpr = window.devicePixelRatio || 1;
    var W = wrap.clientWidth;
    var H = wrap.clientHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    canvas.style.width = W + 'px';
    canvas.style.height = H + 'px';
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    var pad = {top:30, right:20, bottom:50, left:65};
    var cw = W - pad.left - pad.right;
    var ch = H - pad.top - pad.bottom;

    var minV = 0;
    var maxV = Math.ceil(Math.max.apply(null, data.map(function(d){return d.v;})) / 500) * 500;

    function xPos(i) { return pad.left + (i / (data.length - 1)) * cw; }
    function yPos(v) { return pad.top + ch - ((v - minV) / (maxV - minV)) * ch; }

    // Grid
    ctx.strokeStyle = 'rgba(255,255,255,0.06)';
    ctx.lineWidth = 1;
    var steps = 5;
    for (var s = 0; s <= steps; s++) {
      var gv = minV + (maxV - minV) * (s / steps);
      var gy = yPos(gv);
      ctx.beginPath(); ctx.moveTo(pad.left, gy); ctx.lineTo(W - pad.right, gy); ctx.stroke();
      ctx.fillStyle = '#666054';
      ctx.font = '11px Outfit';
      ctx.textAlign = 'right';
      ctx.fillText(Math.round(gv).toLocaleString('sk') + ' €', pad.left - 10, gy + 4);
    }

    // X labels
    ctx.textAlign = 'center';
    ctx.fillStyle = '#666054';
    ctx.font = '11px Outfit';
    for (var i = 0; i < data.length; i++) {
      if (i % 4 === 0 || i === data.length - 1) {
        ctx.fillText(data[i].y, xPos(i), H - pad.bottom + 20);
      }
    }

    // Gradient fill
    var grad = ctx.createLinearGradient(0, pad.top, 0, pad.top + ch);
    grad.addColorStop(0, 'rgba(201,168,76,0.25)');
    grad.addColorStop(0.6, 'rgba(201,168,76,0.08)');
    grad.addColorStop(1, 'rgba(201,168,76,0)');
    ctx.beginPath();
    ctx.moveTo(xPos(0), yPos(data[0].v));
    for (var i = 1; i < data.length; i++) {
      var xc = (xPos(i-1) + xPos(i)) / 2;
      var yc = (yPos(data[i-1].v) + yPos(data[i].v)) / 2;
      ctx.quadraticCurveTo(xPos(i-1), yPos(data[i-1].v), xc, yc);
    }
    ctx.quadraticCurveTo(xPos(data.length-2), yPos(data[data.length-2].v), xPos(data.length-1), yPos(data[data.length-1].v));
    ctx.lineTo(xPos(data.length-1), pad.top + ch);
    ctx.lineTo(xPos(0), pad.top + ch);
    ctx.closePath();
    ctx.fillStyle = grad;
    ctx.fill();

    // Line
    ctx.beginPath();
    ctx.moveTo(xPos(0), yPos(data[0].v));
    for (var i = 1; i < data.length; i++) {
      var xc = (xPos(i-1) + xPos(i)) / 2;
      var yc = (yPos(data[i-1].v) + yPos(data[i].v)) / 2;
      ctx.quadraticCurveTo(xPos(i-1), yPos(data[i-1].v), xc, yc);
    }
    ctx.quadraticCurveTo(xPos(data.length-2), yPos(data[data.length-2].v), xPos(data.length-1), yPos(data[data.length-1].v));
    ctx.strokeStyle = '#C9A84C';
    ctx.lineWidth = 2.5;
    ctx.stroke();

    // Dots at key points
    [0, 5, 10, 15, 20, 24].forEach(function(idx) {
      if (idx >= data.length) return;
      ctx.beginPath();
      ctx.arc(xPos(idx), yPos(data[idx].v), 4, 0, Math.PI * 2);
      ctx.fillStyle = '#C9A84C';
      ctx.fill();
      ctx.strokeStyle = '#161616';
      ctx.lineWidth = 2;
      ctx.stroke();
    });

    // Last point label
    var last = data[data.length - 1];
    ctx.fillStyle = '#C9A84C';
    ctx.font = '600 13px Outfit';
    ctx.textAlign = 'right';
    ctx.fillText(last.v.toLocaleString('sk') + ' €', xPos(data.length-1) - 10, yPos(last.v) - 12);
    ctx.font = '300 10px Outfit';
    ctx.fillStyle = '#A09880';
    ctx.fillText(last.y, xPos(data.length-1) - 10, yPos(last.v) - 0);

    // First point label
    var first = data[0];
    ctx.fillStyle = '#A09880';
    ctx.font = '500 12px Outfit';
    ctx.textAlign = 'left';
    ctx.fillText(first.v + ' €', xPos(0) + 10, yPos(first.v) - 8);
  }

  // Init
  function initGoldChart() {
    if (document.getElementById('aurumGoldChart')) {
      drawGoldChart();
      window.addEventListener('resize', drawGoldChart);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGoldChart);
  } else {
    setTimeout(initGoldChart, 200);
  }

  window.drawGoldChart = drawGoldChart;
})();
